// console.log('v4.3');
import jQuery from 'jquery';
const $ = jQuery;

window.jQuery = $;
window.$ = $;

import 'cssuseragent';
import 'jquery.easing';

// import PerfectScrollbar from 'perfect-scrollbar';

import Swiper, { Pagination, Autoplay } from 'swiper';

// configure Swiper to use modules
Swiper.use([Pagination, Autoplay]);

// import ImgLazyLoad from './module/img-lazy-load';

document.oncontextmenu = function () {
  return false;
};

class SpApp {
  constructor() {}

  AppLoad() {
    $('html, body').scrollTop(0);

    $('.JsLoad').addClass('JsLoad--Done');

    setTimeout(function () {
      $('.Keyvisual').addClass('JsKeyvisual--Done');
      $('.Loader').addClass('JsLoader--Done');
    }, 300);

    setTimeout(function () {
      $('.Keyvisual__logo').addClass('JsKeyvisualLogo--Done');
    }, 1800);

    setTimeout(function () {
      $('.Carousel').addClass('JsCarousel--Done');
      $('.CommonHeader, .AnnotationGuide').addClass('JsCommonHeader--Done');
      $('#stkr').addClass('Jsstkr--Done');
    }, 2300);
  }
}

class scrollIdApp {
  constructor() {}
  ScrollAddId() {
    $('.TitleLocation').each(function (index) {
      index = index + 1;
      $(this)
        .attr('data-id', 'TitleLocation-' + index)
        .attr('id', 'TitleLocation-' + index);
    });
  }
  ScrollIdAppClick() {
    $('a[href^="#"], button[href^="#"]').click(function () {
      // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
      var adjust = -80;
      // スクロールの速度（ミリ秒）
      var speed = 400;
      // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
      var href = $(this).attr('href');
      // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
      var target = $(href == '#' || href == '' ? 'html' : href);
      // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
      var position = target.offset().top + adjust;
      // スムーススクロール linear（等速） or swing（変速）
      $('body,html').animate({ scrollTop: position }, speed, 'swing');
      return false;
    });
  }
}

let ScrollIdApp = new scrollIdApp();
let SpAppv = new SpApp();

function getRandomPositionH() {
  return Math.floor(Math.random() * 30) + 1;
}
function getRandomPositionV() {
  return Math.floor(Math.random() * 100) + 1;
}

var topPos1 = getRandomPositionV();
var leftPos1 = getRandomPositionH();
var topPos2 = getRandomPositionV();
var leftPos2 = getRandomPositionH();
var scroll = $(window).scrollTop();
var whiteArea = $('.Ana_WhiteWrap').offset().top;

$(document).ready(function () {
  // スライダー
  $('.Slider').slick({
    infinite: true,
    fade: true,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 5000,
  });

  // ランダムな穴;
  scroll = $(window).scrollTop();

  $('.Ana_black_1, .Ana_white_1').css({
    left: leftPos1 + 'vw',
  });
  $('.Ana_black_2, .Ana_white_2').css({
    right: leftPos2 + 'vw',
  });
  $('.Ana_black_1').css({
    top: topPos1 + 'vh',
  });
  $('.Ana_black_2').css({
    top: topPos2 + 'vh',
  });
  $('.Ana_white_1').css({
    top: 'calc(' + (scroll - whiteArea) + 'px + ' + topPos1 + 'vh)',
  });
  $('.Ana_white_2').css({
    top: 'calc(' + (scroll - whiteArea) + 'px + ' + topPos2 + 'vh)',
  });
});

$(window).on('load', () => {
  ScrollIdApp.ScrollAddId();
  ScrollIdApp.ScrollIdAppClick();
  SpAppv.AppLoad();
});

$(window).on('scroll resize', () => {
  scroll = $(window).scrollTop();
  whiteArea = $('.Ana_WhiteWrap').offset().top;
  console.log('-' + whiteArea + 'px + ' + topPos1 + 'vh');

  $('.Ana_white_1').css({
    top: 'calc(' + (scroll - whiteArea) + 'px + ' + topPos1 + 'vh)',
  });
  $('.Ana_white_2').css({
    top: 'calc(' + (scroll - whiteArea) + 'px + ' + topPos2 + 'vh)',
  });
});
